module.exports = __webpack_public_path__ + "/static/assets/374b815c6393f1c3585ddeec83c83f48.svg";